import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap-5';
import Select from 'react-select';
import UserProfileToggle from './user_profile_toggle';
import PropTypes from 'prop-types';
import SectionHeader from 'components/form/section_header';

export default function Certification({
  allBrokerCertifications,
  pcUser = false,
  showCertificationsOnDocuments,
  showCertificationsOnEmails,
  showCertificationsOnInventoryPlugin,
  showCertificationsOnBrokerPlugin,
  userCertifications
}) {
  const [checkboxes, setCheckboxes] = useState({
    certificationsOnBrokerPlugin: showCertificationsOnBrokerPlugin,
    certificationsOnInventoryPlugin: showCertificationsOnInventoryPlugin,
    certificationsOnEmails: showCertificationsOnEmails,
    certificationsOnDocuments: showCertificationsOnDocuments
  });

  function changeCheckbox(field) {
    setCheckboxes({ ...checkboxes, [field]: !checkboxes[field] });
  }

  const [selectedCertifications, setSelectedCertifications] = useState(
    userCertifications.map(u => u.brokerCertificationId)
  );

  function changeSelectedCertifications(selectedOptions) {
    setSelectedCertifications(selectedOptions.map(option => option.value));
  }

  const pcUserPrefix = pcUser ? 'parent_company_' : '';

  const certificationsBaseName =
    `${pcUserPrefix}user[${pcUserPrefix}user_broker_certifications_attributes]`;
  const persistedCertificationIds = userCertifications.map(c => c.brokerCertificationId);
  const newCertificationIds = selectedCertifications.filter(c => !persistedCertificationIds.includes(c));

  return (
    <React.Fragment>
      <SectionHeader title="Designations" />
      <Row className="form-group mb-4">
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            options={allBrokerCertifications}
            value={allBrokerCertifications.filter(c => selectedCertifications.includes(c.value))}
            onChange={selectedOptions => changeSelectedCertifications(selectedOptions)}
          />
        </Col>
      </Row>

      {userCertifications.map((userCertification, index) => (
        <React.Fragment key={userCertification.id}>
          <input name={`${certificationsBaseName}[${index}][id]`} type="hidden" value={userCertification.id}/>
          <input
            name={`${certificationsBaseName}[${index}][broker_certification_id]`}
            type="hidden"
            value={userCertification.brokerCertificationId}
          />
          <input
            name={`${certificationsBaseName}[${index}][_destroy]`}
            type="hidden"
            value={!selectedCertifications.includes(userCertification.brokerCertificationId)}
          />
        </React.Fragment>
      ))}

      {newCertificationIds.map((certificationId, i) => {
        const index = i + userCertifications.length;
        return (
          <input
            key={certificationId}
            name={`${certificationsBaseName}[${index}][broker_certification_id]`}
            type="hidden"
            value={certificationId}
          />
        );
      })}

      {!pcUser &&
        <React.Fragment>
          <UserProfileToggle
            checked={checkboxes.certificationsOnBrokerPlugin}
            label="Show on Broker Plugin"
            name="user[show_certifications_on_broker_plugin]"
            onChange={() => changeCheckbox('certificationsOnBrokerPlugin')}
          />
          <div className="d-none">
            <UserProfileToggle
              checked={checkboxes.certificationsOnInventoryPlugin}
              label="Show on Listing Plugin"
              name="user[show_certifications_on_inventory_plugin]"
              onChange={() => changeCheckbox('certificationsOnInventoryPlugin')}
            />
            <UserProfileToggle
              checked={checkboxes.certificationsOnEmails}
              label="Show on Email"
              name="user[show_certifications_on_emails]"
              onChange={() => changeCheckbox('certificationsOnEmails')}
            />
            <UserProfileToggle
              checked={checkboxes.certificationsOnDocuments}
              label="Show on Documents"
              name="user[show_certifications_on_documents]"
              onChange={() => changeCheckbox('certificationsOnDocuments')}
            />
          </div>
        </React.Fragment>
      }
    </React.Fragment>
  );
}

export const certificationPropTypes = {
  allBrokerCertifications: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string
  })).isRequired,
  pcUser: PropTypes.bool,
  showCertificationsOnBrokerPlugin: PropTypes.bool.isRequired,
  showCertificationsOnDocuments: PropTypes.bool.isRequired,
  showCertificationsOnEmails: PropTypes.bool.isRequired,
  showCertificationsOnInventoryPlugin: PropTypes.bool.isRequired,
  userCertifications: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    brokerCertificationId: PropTypes.number
  })).isRequired,
};

Certification.propTypes = certificationPropTypes;
